import { createFileRoute } from '@tanstack/react-router'
import DocumentosDigitaisGeradosPage from '@/pages/dashboard/documentos-digitais-gerados-page'

export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/documentos-digitais/gerados/',
)({
  component: DocumentosDigitaisGeradosPage,
})
